import React, { Fragment } from 'react';

import {
  SWELL_INTEGRATIONS,
  integrationActivated,
  integrationLive,
  swellIntegrationName,
} from 'shared/integrations';

// The React half of an integration, keyed by id. Everything else about them
// (id, name, description, sync, externallink) is plain data in
// shared/integrations so the server can read the same list — see the note
// there. Only integrations that say something about how they are connected
// need an entry.
const CONNECTED_RENDERERS = {
  avatax: (values) => (
    <Fragment>
      {values.environment === 'production' ? (
        <span>
          with company code <b>{values.production_company_code}</b>
        </span>
      ) : (
        <span>
          in <u className="muted">sandbox mode</u> with company code{' '}
          <b>{values.sandbox_company_code}</b>
        </span>
      )}
    </Fragment>
  ),
  mailchimp: (values) => (
    <Fragment>
      {values.list_name ? (
        <span>
          with <b>{values.list_name}</b>
        </span>
      ) : null}
    </Fragment>
  ),
  taxjar: (values) => (
    <Fragment>
      {values.environment === 'production' ? (
        <span>
          in <u className="muted">production mode</u>
        </span>
      ) : (
        <span>
          in <u className="muted">sandbox mode</u>
        </span>
      )}
    </Fragment>
  ),
  slack: (values) => (
    <Fragment>
      with site ID <b>{values.site_id}</b>
    </Fragment>
  ),
  segment: (values) => (
    <Fragment>
      <span>
        with Write Key <b>{values.write_key}</b>
      </span>
    </Fragment>
  ),
  omnisend: (values) => (
    <Fragment>
      with store URL <b>{values.store_url}</b>
    </Fragment>
  ),
  klaviyo: (values) => (
    <Fragment>
      with site ID <b>{values.site_id}</b>
    </Fragment>
  ),
};

export const INTEGRATIONS = SWELL_INTEGRATIONS.map((integration) =>
  CONNECTED_RENDERERS[integration.id]
    ? { ...integration, renderConnected: CONNECTED_RENDERERS[integration.id] }
    : integration,
);

export function integrationName(id) {
  return swellIntegrationName(id);
}

export { integrationActivated, integrationLive };
